<script>
	import { onMount } from 'svelte';
	import Page from './Page.svelte';

	let vh;
	onMount(() => {
		// create true vh
		document.documentElement.style.setProperty('--vh', `${vh / 100}px`);
	});
</script>

<!-- meta and window -->
<svelte:window bind:innerHeight={vh} />

<!-- actual content -->
<Page />
